import { render, staticRenderFns } from "./CharacterFields.vue?vue&type=template&id=6ba54b02&scoped=true&"
import script from "./CharacterFields.vue?vue&type=script&lang=js&"
export * from "./CharacterFields.vue?vue&type=script&lang=js&"
import style0 from "./CharacterFields.vue?vue&type=style&index=0&id=6ba54b02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba54b02",
  null
  
)

export default component.exports